import React from "react";
import styled from "styled-components";
import { UserToken } from '../../../../../amorg-common';
import { Icon } from "../../../../icons/Icons";
import { Flex, FlexItem } from "../../../../compositeComponents/FlexHelpers";


type UserPanelProps =
{
    activeUser:UserToken
}
export function UserPanel(props:UserPanelProps):JSX.Element
{
    return (
        <>
            {props.activeUser &&
                <UserPanelWrapper>
                    <Flex flexDirection="column" gap={16}>
                    
                        {/* <Flex flexDirection="row" gap={4}>
                            <Icon name={"interface_user_account"} size='x-small' color="white" noHover />
                            
                            <P color="white">
                                {props.activeUser.name}
                            </P>
                            
                        </Flex> */}

                        <UserLinks>                            
                            <Flex flexDirection="row" justifyContent='space-between'>
                                <FlexItem>
                                <a href="/profile">
                                    <Flex flexDirection="row" gap={4}>
                                        <Icon name={"navigation_settings"} size={"x-small"} color={"white"} />
                                        <span>Rediger profil</span>
                                    </Flex>
                                </a>
                                </FlexItem>
                                <FlexItem>
                                <a href="/logout">
                                    <Flex flexDirection="row" gap={4}>
                                        <Icon name={"logout"} size={"x-small"} color={"white"} />
                                        <span>Log ud</span>
                                    </Flex>
                                </a>
                                </FlexItem>
                            </Flex>
                        </UserLinks>
                    </Flex>
                </UserPanelWrapper>
            }
        </>
    );
}

const UserPanelWrapper = styled.div`
    padding:15px;
    border-radius: 4px;
    background-color: ${props => props.theme.colors.mainNavigation.backgroundSelected};
`


const UserLinks = styled.div`
    
    & a{
        color:white;
        text-decoration:none;

        &:hover {
            color: white;
        }

        &:hover svg{
            fill: white;
        }
    }

    
`;